import { ICompanyDataModel } from '../../../../../data-models/company.data-model';
import { IAssignTemplateParams } from '../hooks/useTemplateAssignmentActions';
import { BulkAssignTemplatePayload } from '../../../../../services/queries/KPITemplatesQueries';

/**
 * Needs an FYE and someone to collect from. Respondents count from either system: Maggie's
 * `company.respondents`, or Starbreaker for onboarded portcos (whose Maggie copy stays empty).
 * Defaults to the Maggie-only rule; `useValidateCompanyData` supplies the Starbreaker half.
 */
export function validateCompanyData(company: ICompanyDataModel, hasExternalRespondents = false) {
  const { fye, respondents } = company;
  return fye != null && (hasExternalRespondents || (respondents != null && respondents.length > 0));
}

export function prepareBulkAssignPayload(payload: IAssignTemplateParams): BulkAssignTemplatePayload[] {
  const { companyIds, ...templateData } = payload;
  return companyIds.map((companyId) => {
    return { ...templateData, companyId } as BulkAssignTemplatePayload;
  });
}
